var $ffeb903ba092eb35$exports = {};
$ffeb903ba092eb35$exports = {
  "removeButtonLabel": "\u05D4\u05E1\u05E8",
  "removeDescription": "\u05DC\u05D7\u05E5 \u05E2\u05DC \u05DE\u05D7\u05E7 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05E1\u05D9\u05E8 \u05EA\u05D2."
};
export { $ffeb903ba092eb35$exports as default };